import { computed } from 'vue';
import { useMedicalRecords } from '@/composables/use-medical-records';
import { usePatient } from '@/composables/use-patients';
import { useEncounters } from '@/composables/use-encounters';
import { RECORD_TYPE, UPDATE_FIELDS } from './constants';

export function usePedia () {
  const {
    medicalRecords,
    create: createMedicalRecord,
    update: updateMedicalRecord,
    remove: removeMedicalRecord,
  } = useMedicalRecords();

  const { patient } = usePatient();
  const { encounter } = useEncounters();

  const records = computed({
    get () {
      return medicalRecords.value.filter((record) => record.type === RECORD_TYPE);
    },
    set ({ type, data }) {
      if (type === 'create') {
        records.value.unshift(data);
      }

      if (type === 'update') {
        const index = records.value.findIndex((record) => record.id === data.id);
        records.value.splice(index, 1, data);
      }

      if (type === 'remove') {
        const index = records.value.findIndex((record) => record.id === data.id);
        records.value.splice(index, 1);
      }
    },
  });

  const submit = async (payload) => {
    if (payload?.id) {
      const id = payload.id;
      payload = Object.keys(payload).reduce((acc, key) => {
        if (UPDATE_FIELDS.includes(key) && payload[key] !== null && payload[key] !== undefined && payload[key] !== '') {
          acc[key] = payload[key];
        }
        return acc;
      }, {});
      data = await updateMedicalRecord(id, payload);
      records.value = {
        type: 'update',
        data,
      };
    } else {
      payload.type = RECORD_TYPE;
      payload.encounter = encounter.value?.id;
      payload.patient = patient.value?.id;
      data = await createMedicalRecord(payload);
      records.value = {
        type: 'create',
        data,
      };
    }
  };

  const remove = async ({ id }) => {
    await removeMedicalRecord(id);
  };

  return {
    medicalRecords,
    records,
    submit,
    remove,
  };
}
